import useSWR from "swr";
import { api } from "@/lib/api";
import { CurrencyBtc, ChartLine, Fire } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function MarketOverview() {
  const { data } = useSWR("overview", () => api.overview(), {
    refreshInterval: 60000,
  });
  const g = data?.crypto_global;
  const trending = data?.crypto_trending || [];

  return (
    <div className="border border-zinc-800 grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_minmax(0,2fr)]" data-testid="market-overview">
      <div className="p-6 border-b lg:border-b-0 lg:border-r border-zinc-800">
        <div className="overline">Crypto Market</div>
        <div className="mt-3 space-y-3">
          <StatRow
            icon={<CurrencyBtc size={14} weight="bold" />}
            label="Total Market Cap"
            value={g ? `$${(g.total_market_cap_usd / 1e12).toFixed(2)}T` : "—"}
            change={g?.market_cap_change_pct_24h}
          />
          <StatRow
            icon={<ChartLine size={14} weight="bold" />}
            label="24h Volume"
            value={g ? `$${(g.total_volume_usd / 1e9).toFixed(1)}B` : "—"}
          />
          <StatRow
            label="BTC Dominance"
            value={g ? `${g.btc_dominance.toFixed(1)}%` : "—"}
          />
          <StatRow
            label="ETH Dominance"
            value={g ? `${g.eth_dominance.toFixed(1)}%` : "—"}
          />
          <StatRow
            label="Active Cryptos"
            value={g ? g.active_cryptos.toLocaleString() : "—"}
          />
        </div>
      </div>

      <div className="p-6">
        <div className="flex items-center gap-2 overline">
          <Fire size={12} weight="fill" className="text-[#FFD600]" />
          Trending Now
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-0 mt-3 border border-zinc-800">
          {trending.length === 0 && (
            <div className="col-span-full p-4 text-xs text-zinc-500">
              Loading trending coins…
            </div>
          )}
          {trending.map((c) => (
            <Link
              key={c.coin_id}
              to={`/ticker/crypto/${encodeURIComponent(c.coin_id)}`}
              data-testid={`trending-${c.symbol}`}
              className="p-3 border-b border-r border-zinc-800 hover:bg-[#141414] transition-colors group"
            >
              <div className="flex items-center gap-2">
                {c.image && <img src={c.image} alt="" className="w-4 h-4" />}
                <span className="font-bold text-white text-xs">{c.symbol}</span>
                {c.market_cap_rank && (
                  <span className="ml-auto text-[10px] text-zinc-500">
                    #{c.market_cap_rank}
                  </span>
                )}
              </div>
              <div className="mt-1 text-[11px] text-zinc-500 truncate">{c.name}</div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

function StatRow({ icon, label, value, change }) {
  return (
    <div className="flex items-center justify-between text-sm">
      <span className="text-zinc-500 flex items-center gap-2 text-xs">
        {icon}
        {label}
      </span>
      <span className="tabular text-white">
        {value}
        {typeof change === "number" && (
          <span
            className={`ml-2 text-[11px] ${
              change >= 0 ? "text-[#00FF66]" : "text-[#FF3B30]"
            }`}
          >
            {change >= 0 ? "+" : ""}
            {change.toFixed(2)}%
          </span>
        )}
      </span>
    </div>
  );
}
